import { render, staticRenderFns } from "./VenueListItem.vue?vue&type=template&id=2678150e&"
import script from "./VenueListItem.vue?vue&type=script&lang=js&"
export * from "./VenueListItem.vue?vue&type=script&lang=js&"
import style0 from "./VenueListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports